import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToSeconds',
})
export class DateToSecondsPipe implements PipeTransform {
  transform(value: Date | string | number): number {
    return new Date(value).getTime();
  }
}
